import { createRouter, createWebHistory } from 'vue-router';
import { store } from '@/store/store';

// Lazy-load route components so each view ships as its own chunk,
// keeping the app entrypoint small.
const MyProfile = () => import('@/components/MyProfile.vue');
const TestPage = () => import('@/views/TestPage.vue');
const BookDetails = () => import('@/views/BookDetails.vue');
const LoginPage = () => import('@/views/LoginPage.vue');
// const OrdersPage = () => import('@/views/OrdersPage.vue');
const DashboardPage = () => import('@/views/DashboardPage.vue');
const AllBooks = () => import('@/views/AllBooks.vue');
const UpdateBook = () => import('@/components/UpdateBook.vue');
const AddBook = () => import('@/components/AddBook.vue');
const ManageOrders = () => import('@/components/ManageOrders.vue');
const EditOrder = () => import('@/components/EditOrder.vue');
const ManageUsers = () => import('@/components/ManageUsers.vue');
const EditUser = () => import('@/components/EditUser.vue');
const ManageCategories = () => import('@/components/ManageCategories.vue');
const ManageRequests = () => import('@/components/ManageRequests.vue');
const HomepageBanners = () => import('@/components/HomepageBanners.vue');
const HomepageBookSections = () => import('@/components/HomepageBookSections.vue');
const ContactFormSubmissions = () => import('@/views/ContactFormSubmissions.vue');
const CouponAdmin = () => import('@/views/CouponAdmin.vue');

const routes = [
  { path: '/', component: LoginPage },
  { path: '/book/:id', name: 'ProductDetails', component: BookDetails },
  { path: '/dashboard', component: DashboardPage, meta: { requiresAuth: true } },
  { path: '/profile', component: MyProfile, meta: { requiresAuth: true }  },
  { path: '/books', component: AllBooks, meta: { requiresAuth: true }  },
  {
    path: '/admin/books/edit/:id',
    name: 'UpdateBook',
    component: UpdateBook,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/books/add',
    name: 'AddBook',
    component: AddBook,
    props: true,
    meta: { requiresAuth: true }
  },
  { path: '/users', component: ManageUsers, meta: { requiresAuth: true }  },
  {
    path: '/users/update/:id',
    name: 'EditUser',
    component: EditUser,
    props: true,
    meta: { requiresAuth: true }
  },
  { path: '/orders', component: ManageOrders, meta: { requiresAuth: true }  },
  {
    path: '/orders/update/:id',
    name: 'EditOrder',
    component: EditOrder,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/categories',
    name: 'ManageCategories',
    component: ManageCategories,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/request',
    name: 'ManageRequests',
    component: ManageRequests,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/banners',
    name: 'HomepageBanners',
    component: HomepageBanners,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/homepage-sections',
    name: 'HomepageBookSections',
    component: HomepageBookSections,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/contact-form-submissions',
    name: 'ContactFormSubmissions',
    component: ContactFormSubmissions,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/coupons',
    name: 'CouponAdmin',
    component: CouponAdmin,
    meta: { requiresAuth: true }
  },
  { path: '/test', component: TestPage, meta: { requiresAuth: true } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation Guard for Auth
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/');
  } else {
    next();
  }
});

export default router;
